<template>
  <select class="form-control form-control-sm" ref="combo" :value="value" :disabled="disabled" @change="updateCombo()">
    <option v-if="todos && !cleaned" value="null">{{nullText}}</option>
    
    <option
      v-for="item in items"
      v-bind:key="item[propertyID]"
      :value="item[propertyID]"
    >{{item[propertyName]}}
    </option>

  </select>
</template>

<script>
export default {
  props: {
    items: Array,
    propertyName: String,
    propertyID: String,
    todos: {
      type: Boolean,
      default: false
    },
    value: Number,
    nullText: {
      type: String,
      default: "Todos"
    },
    cleanDefault: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cleaned: false
    };
  },
  methods: {
    updateCombo() {
      var valueParsed = 0;
      try {
        valueParsed = parseInt(this.$refs.combo.value);
      } catch (ex) {
        valueParsed = 0;
      }

      if (this.cleanDefault && !this.cleaned) {
        this.cleaned = true;
      }

      this.$emit("input", valueParsed);
    }
  }
};
</script>